// Single public contact address for the site. Every member-facing "contact us"
// reference (info pages, terms, privacy/HIPAA copy) reads from here so the
// address only ever has to change in one place.
export const CONTACT_EMAIL = 'roberth@thrivelonger.ai';
